import { useMemo, type ReactNode } from "react";
import { pieChartSpec, type PieChartSpecOptions } from "../specs/pie.js";
import type { ChartData } from "../types.js";
import { VegaChart } from "./VegaChart.js";
import type { ChartContainerProps } from "./shared.js";

export interface PieChartProps
  extends PieChartSpecOptions, ChartContainerProps {
  data: ChartData;
}

/** A themed pie chart. Pass `donut` to render a donut instead. */
export function PieChart({
  data,
  category,
  categoryType,
  value,
  donut,
  title,
  subtitle,
  ...container
}: PieChartProps): ReactNode {
  const spec = useMemo(
    () =>
      pieChartSpec({
        data,
        category,
        categoryType,
        value,
        donut,
        title,
        subtitle,
      }),
    [data, category, categoryType, value, donut, title, subtitle],
  );

  return <VegaChart spec={spec} {...container} />;
}
